module.exports = __webpack_public_path__ + "media/icons/user-plus-cc1a1efd3313eb4f8245e46ceaee4448.svg";